import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { API_URL } from '..';
import Swal from 'sweetalert2';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Icon } from '@iconify/react';
import { Modal, Button } from 'react-bootstrap';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ';

function formatDateString(dateStr) {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '-';
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}

const QuoteListLayer = ({ jobsData = [] }) => {
  const mapContainerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '8px',
    border: '1px solid #ced4da',
  };

  const defaultCenter = {
    lat: 51.5074,
    lng: -0.1276,
  };

  const navigate = useNavigate();
  const [postCode, setPostCode] = useState('');
  const [currentUser, setCurrentUser] = useState({});
  const [createJob, setCreateJob] = useState(false);
  const [selectedElectricians, setSelectedElectricians] = useState([]);
  const [selectedWorkforceIds, setSelectedWorkforceIds] = useState([]);
  const [errors, setErrors] = useState({});
  const [jobDescription, setJobDescription] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalQuoteId, setModalQuoteId] = useState(null);
  const [enableGeofencing, setEnableGeofencing] = useState(false);
  const [radius, setRadius] = useState(100);
  const [isJobLocationCustomerAddress, setIsJobLocationCustomerAddress] = useState(true);
  const [jobLocation, setJobLocation] = useState('');
  const [jobLocationCoordinates, setJobLocationCoordinates] = useState(null);
  const [jobLocationSuggestions, setJobLocationSuggestions] = useState([]);
  const [expandedMobileCards, setExpandedMobileCards] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [cityList, setCityList] = useState([]);
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [biltyTo, setBiltyTo] = useState(null);
  const [commission, setCommission] = useState('');

  const biltyOptions = useMemo(() => {
    const opts = [
      { label: 'Select Sub Branch', value: '' },
      { label: 'Head Office', value: 'Head Office' }
    ];
    if (Array.isArray(cityList)) {
      cityList.forEach((c) => {
        const name = (c.name || c.cityName || '').trim();
        if (name && name.toLowerCase() !== 'head office') {
          opts.push({ label: name, value: name });
        }
      });
    }
    if (biltyTo && !opts.some((o) => o.value.toLowerCase() === biltyTo.toLowerCase())) {
      opts.push({ label: biltyTo, value: biltyTo });
    }
    return opts;
  }, [cityList, biltyTo]);

  const filteredJobsData = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return jobsData;
    return jobsData.filter((quote) => {
      const cityName = quote?.city?.name || cityList.find((c) => c.id === quote?.cityId || String(c.id) === String(quote?.cityId))?.name || '';
      const creatorName = quote?.creator?.name || '';
      const searchable = [
        quote?.invoice_number,
        quote?.customer_name,
        quote?.phone,
        quote?.amount,
        cityName,
        creatorName,
      ].filter(Boolean).join(' ').toLowerCase();
      return searchable.includes(query);
    });
  }, [jobsData, searchQuery, cityList]);

  const jobDescriptionQuillRef = useRef(null);
  const jobDescriptionQuillInstance = useRef(null);
  const jobLocationInputRef = useRef(null);

  const privileges = useMemo(() => {
    const storedPrivileges = localStorage.getItem('privilages');
    return storedPrivileges
      ? JSON.parse(storedPrivileges)
      : { quotes: { edit: false, delete: false, read: false, changeStatus: false } };
  }, []);

  const isAdmin = currentUser?.roles?.role !== 'user';
  const canRead = isAdmin || privileges?.quotes?.read;
  const canEdit = isAdmin || privileges?.quotes?.edit;
  const canDelete = isAdmin || privileges?.quotes?.delete;
  const canMakeInvoice = isAdmin || privileges?.quotes?.changeStatus;

  const toggleMobileDetails = (quoteId) => {
    setExpandedMobileCards((prev) => ({
      ...prev,
      [quoteId]: !prev[quoteId],
    }));
  };

  const formatMoney = (quote) => {
    const currency = quote?.currency || '';
    const amount = Number(quote?.amount || quote?.totalAmount || 0);
    return `${currency} ${amount.toFixed(2)}`;
  };

  const fetchCoordinates = async (address) => {
    if (!address) return { latitude: '', longitude: '' };
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          address
        )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB&limit=1`
      );
      const data = await response.json();
      if (data.features?.length > 0) {
        const [longitude, latitude] = data.features[0].geometry.coordinates;
        return { latitude, longitude };
      }
      return { latitude: '', longitude: '' };
    } catch (error) {
      console.error('Error fetching coordinates:', error);
      return { latitude: '', longitude: '' };
    }
  };

  const handleDelete = async (id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/sign-in');
      return;
    }

    const confirm = await Swal.fire({
      icon: 'warning',
      title: 'Delete quote?',
      text: 'This action cannot be undone.',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#111827',
    });

    if (!confirm.isConfirmed) return;

    try {
      const headersList = {
        Accept: '*/*',
        'Content-Type': 'application/json',
      };

      const response = await fetch(`${API_URL}/api/invoice/delete-invoice/${id}`, {
        method: 'DELETE',
        headers: headersList,
      });

      const data = await response.json();

      if (data.message === 'Invoice deleted successfully') {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Quote deleted successfully!',
          confirmButtonColor: '#111827',
        });
        window.location.reload();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.message || 'Failed to delete quote',
          confirmButtonColor: '#111827',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Failed to delete quote: ${error.message}`,
        confirmButtonColor: '#111827',
      });
    }
  };

  const handleMakeIt = (id) => {
    const quote = jobsData.find((job) => job.id === id);

    if (!quote) {
      setShowModal(false);
      return;
    }

    setModalQuoteId(id);
    setCreateJob(false);
    setShowOtherDetails(false);
    setBiltyTo(quote?.bilty_to || null);
    setCommission(quote?.commission || '');
    setSelectedElectricians([]);
    setSelectedWorkforceIds([]);
    setErrors({});
    setJobDescription('');
    setIsJobLocationCustomerAddress(true);
    setJobLocation('');
    setJobLocationCoordinates(null);
    setJobLocationSuggestions([]);
    setEnableGeofencing(false);
    setRadius(100);
    setShowModal(true);
  };

  const closeConvertModal = () => {
    setShowModal(false);
    setModalQuoteId(null);
    setShowOtherDetails(false);
    setBiltyTo(null);
    setCommission('');
    setCreateJob(false);
    setSelectedElectricians([]);
    setSelectedWorkforceIds([]);
    setErrors({});
    setJobDescription('');
    setIsJobLocationCustomerAddress(true);
    setJobLocation('');
    setJobLocationCoordinates(null);
    setJobLocationSuggestions([]);
    setEnableGeofencing(false);
    setRadius(100);
  };

  const handleJobLocationSelect = (selected) => {
    if (selected) {
      setJobLocation(selected.value);
      setJobLocationCoordinates({
        latitude: selected.coordinates[1],
        longitude: selected.coordinates[0],
      });
      setJobLocationSuggestions([]);
      setErrors((prev) => ({ ...prev, jobLocation: null }));
    }
  };

  const handleSubmit = async () => {
    const newErrors = {};

    if (createJob) {
      if (selectedElectricians.length === 0) {
        newErrors.electricians = 'At least one electrician must be selected';
      }

      if (!isJobLocationCustomerAddress && !jobLocation) {
        newErrors.jobLocation = 'Job location is required';
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }
    }

    try {
      const quote = jobsData.find((job) => job.id === modalQuoteId);
      const user = JSON.parse(localStorage.getItem('user'));

      if (!quote) throw new Error('Quote not found');

      const invoiceResponse = await fetch(`${API_URL}/api/invoice/convert-to-invoice/${modalQuoteId}`, {
        method: 'PUT',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          bilty_to: biltyTo ? biltyTo.trim() : null,
          commission: commission ? commission.trim() : null,
        }),
      });

      const invoiceData = await invoiceResponse.json();

      if (invoiceData.message !== 'success') {
        throw new Error(invoiceData.error || invoiceData.message || 'Failed to convert quote to order form');
      }

      closeConvertModal();

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: createJob
          ? 'Quote converted to order form and job created successfully!'
          : 'Quote converted to order form successfully!',
        confirmButtonColor: '#111827',
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      setErrors({ ...errors, submit: error.message });

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'An error occurred',
        confirmButtonColor: '#111827',
      });
    }
  };

  const getActionsColumn = (data, type, row) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const storedPrivileges = localStorage.getItem('privilages');
    const currentPrivileges = storedPrivileges
      ? JSON.parse(storedPrivileges)
      : { quotes: { edit: false, delete: false, read: false, changeStatus: false } };

    const tableIsAdmin = user?.roles?.role !== 'user';
    const actions = [];
   if (tableIsAdmin || currentPrivileges?.quotes?.read) {
      actions.push(
        `<li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye me-2"></i>View Quote</a></li>`
      );
    }
    if (tableIsAdmin || currentPrivileges?.quotes?.changeStatus) {
      actions.push(
        `<li><a style="cursor:pointer" class="dropdown-item make-btn" data-id="${row.id}"><i class="ph ph-file-arrow-up me-2"></i>Make it Order Form</a></li>`
      );
    }

 

    if (tableIsAdmin || currentPrivileges?.quotes?.edit) {
      actions.push(
        `<li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil me-2"></i>Edit Quote</a></li>`
      );
    }

    if (tableIsAdmin || currentPrivileges?.quotes?.delete) {
      actions.push(
        `<li><a style="cursor:pointer" class="dropdown-item delete-btn text-danger" data-id="${row.id}"><i class="ph ph-trash me-2"></i>Delete Quote</a></li>`
      );
    }

    if (actions.length === 0) {
      return '<span class="text-muted small">No actions</span>';
    }

    return `
      <div class="dropdown quote-actions-dropdown">
        <button class="quote-action-toggle dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport" data-bs-display="dynamic" aria-expanded="false">
          Actions
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          ${actions.join('')}
        </ul>
      </div>
    `;
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user) {
      navigate('/sign-in');
      return;
    }

    setCurrentUser(user);

    // Fetch cities for display in table
    fetch(`${API_URL}/api/city`)
      .then((r) => r.json())
      .then((data) => setCityList(data))
      .catch(() => {});
  }, [navigate]);

  useEffect(() => {
    if (!jobsData || jobsData.length === 0) return;

    if ($.fn.DataTable.isDataTable('#dataTable')) {
      $('#dataTable').DataTable().clear().destroy();
      $('#dataTable tbody').off('click');
    }

    const table = $('#dataTable').DataTable({
      data: filteredJobsData,
      responsive: true,
      scrollX: false,
      autoWidth: false,
      pageLength: 10,
      order: [[0, 'desc']],
      dom: 'rt<"quote-datatable-footer"lip>',
      language: {
        search: '',
        searchPlaceholder: 'Search quotes...',
      },
      columnDefs: [
        { responsivePriority: 1, targets: 1 },
        { responsivePriority: 2, targets: 5 },
        { responsivePriority: 3, targets: 4 },
        { responsivePriority: 4, targets: 3 },
      ],
      columns: [
              {
  data: 'invoice_number',
  width: '70px',
  render: (data, type, row) => `
    <a href="/quote-preview/${row.id}" class="fw-bold text-decoration-underline">
      ${data || `Quote #${row.id}`}
    </a>
  `,
},
        { data: 'customer_name', width: '190px' },
        { data: 'phone', width: '150px' },
        {
          data: 'issue_date',
          width: '130px',
          render: (data) => `<span>${formatDateString(data)}</span>`,
        },
        {
          data: 'amount',
          width: '140px',
          render: (data, type, row) => `<span>${row.currency || ''} ${parseFloat(data || 0).toFixed(2)}</span>`,
        },
        // {
        //   data: 'cityId',
        //   width: '110px',
        //   title: 'City',
        //   render: (data, type, row) => {
        //     const cityName = row?.city?.name || cityList.find((c) => c.id === data || String(c.id) === String(data))?.name;
        //     return cityName ? `<span class="badge bg-light text-dark border">${cityName}</span>` : '<span class="text-muted small">—</span>';
        //   },
        // },
        {
          data: null,
          render: getActionsColumn,
          title: 'Actions',
          orderable: false,
          width: '120px',
        },
      ],
    });

    $('#dataTable tbody').on('click', '.edit-btn', function () {
      const id = $(this).data('id');
      navigate(`/quote-edit/${id}`);
    });

    $('#dataTable tbody').on('click', '.view-btn', function () {
      const id = $(this).data('id');
      navigate(`/quote-preview/${id}`);
    });

    $('#dataTable tbody').on('click', '.delete-btn', function () {
      const id = $(this).data('id');
      handleDelete(id);
    });

    $('#dataTable tbody').on('click', '.make-btn', function () {
      const id = $(this).data('id');
      handleMakeIt(id);
    });

    return () => {
      $('#dataTable tbody').off('click');

      if ($.fn.DataTable.isDataTable('#dataTable')) {
        table.destroy();
      }
    };
  }, [filteredJobsData, navigate]);

  return (
    <div className="quote-list-page">
      <style>
        {`
          .quote-list-page {
            --quote-primary: #111827;
            --quote-muted: #6b7280;
            --quote-border: #e5e7eb;
            --quote-soft: #f9fafb;
            --quote-card: #ffffff;
            --quote-danger: #b91c1c;
            --quote-success: #166534;
          }

          .quote-list-card {
            border: 1px solid var(--quote-border);
            border-radius: 18px;
            background: var(--quote-card);
            box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
            overflow: visible;
          }

          .quote-list-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            padding: 20px 22px;
            border-bottom: 1px solid var(--quote-border);
          }

          .quote-list-title {
            margin: 0;
            color: var(--quote-primary);
            font-size: 18px;
            font-weight: 850;
            letter-spacing: -0.02em;
          }

          .quote-list-subtitle {
            margin: 4px 0 0;
            color: var(--quote-muted);
            font-size: 13px;
          }

          .quote-add-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-height: 42px;
            padding: 10px 16px;
            border-radius: 12px;
            background: var(--quote-primary);
            color: #fff !important;
            text-decoration: none;
            font-size: 14px;
            font-weight: 800;
            border: 1px solid var(--quote-primary);
            transition: all .15s ease;
          }

          .quote-add-btn:hover {
            background: #1f2937;
            transform: translateY(-1px);
          }

          .quote-datatable-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 14px;
            margin-top: 14px;
          }

          .quote-search-section {
            padding: 16px 22px 0;
            background: #fff;
          }

          .quote-search-wrap {
            position: relative;
            max-width: 420px;
          }

          .quote-search-icon {
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            color: #9ca3af;
            font-size: 16px;
            z-index: 2;
          }

          .quote-search-input {
            width: 100%;
            min-height: 44px;
            border-radius: 12px;
            border: 1px solid var(--quote-border);
            padding: 9px 38px 9px 40px;
            color: var(--quote-primary);
            font-size: 14px;
            font-weight: 650;
            outline: none;
            transition: all .15s ease;
          }

          .quote-search-input:focus {
            border-color: var(--quote-primary);
            box-shadow: 0 0 0 4px rgba(17, 24, 39, 0.08);
          }

          .quote-search-clear {
            position: absolute;
            right: 9px;
            top: 50%;
            transform: translateY(-50%);
            width: 28px;
            height: 28px;
            border-radius: 999px;
            border: 0;
            background: #f3f4f6;
            color: var(--quote-primary);
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }

          .quote-search-meta {
            margin-top: 8px;
            color: var(--quote-muted);
            font-size: 12px;
            font-weight: 700;
          }

          @media (max-width: 991px) {
            .quote-search-wrap {
              max-width: 100%;
            }
          }

          .quote-list-body {
            padding: 0 0 22px;
          }

          .desktop-table-wrap {
            display: block;
            width: 100%;
            overflow: visible;
            padding: 16px 22px 0;
          }

          .mobile-quote-list {
            display: none;
          }

          .table-responsive-shell {
            width: 100%;
            overflow: visible !important;
            -webkit-overflow-scrolling: touch;
          }

          .quote-list-page,
          .quote-list-card,
          .quote-list-body,
          .desktop-table-wrap,
          .table-responsive-shell,
          .dataTables_wrapper,
          .dataTables_scroll,
          .dataTables_scrollHead,
          .dataTables_scrollBody,
          table.dataTable,
          table.dataTable tbody,
          table.dataTable tr,
          table.dataTable td {
            overflow: visible !important;
          }

          .table-responsive-shell {
            position: relative;
            z-index: 1;
          }

          .table-responsive-shell:has(.dropdown-menu.show),
          .dataTables_wrapper:has(.dropdown-menu.show),
          .quote-list-card:has(.dropdown-menu.show) {
            z-index: 99999;
          }

          #dataTable tbody tr,
          #dataTable tbody td {
            position: relative;
            z-index: 1;
          }

          #dataTable tbody tr:has(.dropdown-menu.show),
          #dataTable tbody td:has(.dropdown-menu.show) {
            position: relative;
            z-index: 1000000 !important;
          }

          #dataTable tbody tr:has(.dropdown-menu.show) ~ tr,
          #dataTable tbody tr:has(.dropdown-menu.show) ~ tr td,
          #dataTable tbody tr:has(.dropdown-menu.show) ~ tr .quote-actions-dropdown {
            z-index: 1 !important;
          }

          .quote-actions-dropdown .dropdown-menu.show {
            display: block;
            position: absolute !important;
            z-index: 1000001 !important;
            inset: auto 0 auto auto !important;
            transform: translate3d(0, 38px, 0) !important;
            isolation: isolate;
          }

          #dataTable {
            width: 100% !important;
            min-width: 780px;
          }

          #dataTable thead th {
            background: #f9fafb;
            color: #374151;
            font-size: 12px;
            font-weight: 850;
            border-bottom: 1px solid var(--quote-border);
            white-space: nowrap;
          }

          #dataTable tbody td {
            vertical-align: middle;
            color: #111827;
            font-size: 13px;
            white-space: nowrap;
          }

          .dataTables_wrapper .dataTables_filter input,
          .dataTables_wrapper .dataTables_length select {
            border: 1px solid var(--quote-border);
            border-radius: 10px;
            min-height: 38px;
            padding: 7px 10px;
            outline: none;
          }

          .dataTables_wrapper .dataTables_filter input:focus,
          .dataTables_wrapper .dataTables_length select:focus {
            border-color: var(--quote-primary);
            box-shadow: 0 0 0 4px rgba(17, 24, 39, 0.08);
          }

          .quote-actions-dropdown {
            position: relative;
            z-index: 1;
            display: inline-block;
          }

          .quote-actions-dropdown:has(.dropdown-menu.show) {
            z-index: 1000000 !important;
          }

          .quote-actions-dropdown .dropdown-menu {
            z-index: 1000001;
            border-radius: 12px;
            border: 1px solid var(--quote-border);
            box-shadow: 0 18px 38px rgba(15, 23, 42, 0.14);
            padding: 6px;
          }

          .quote-actions-dropdown .dropdown-item {
            border-radius: 9px;
            font-size: 13px;
            padding: 9px 11px;
          }


          .quote-actions-dropdown.show,
          .quote-actions-dropdown .dropdown-menu.show {
            z-index: 1000001 !important;
          }

          .quote-actions-dropdown .dropdown-menu.show * {
            position: relative;
            z-index: 1000002;
          }

          .quote-action-toggle {
            border: 1px solid var(--quote-border);
            background: #fff;
            color: var(--quote-primary);
            border-radius: 10px;
            min-height: 36px;
            padding: 7px 11px;
            font-size: 13px;
            font-weight: 800;
          }

          .quote-mobile-card {
            border: 1px solid var(--quote-border);
            border-radius: 16px;
            background: #fff;
            padding: 15px;
            box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
            position: relative;
            z-index: 1;
          }

          .quote-mobile-card:has(.dropdown-menu.show) {
            z-index: 99999 !important;
          }

          .quote-mobile-card + .quote-mobile-card {
            margin-top: 12px;
          }

          .quote-mobile-top {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            align-items: flex-start;
            margin-bottom: 12px;
          }

          .quote-mobile-main {
            min-width: 0;
            flex: 1 1 auto;
          }

          .quote-mobile-number {
            color: var(--quote-primary);
            font-size: 15px;
            font-weight: 900;
            word-break: break-word;
          }

          .quote-mobile-customer {
            margin-top: 5px;
            color: var(--quote-muted);
            font-size: 13px;
            font-weight: 700;
            word-break: break-word;
          }

          .quote-mobile-status-area {
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            gap: 8px;
            flex: 0 0 auto;
          }

          .quote-amount-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 999px;
            padding: 7px 11px;
            background: #f9fafb;
            border: 1px solid var(--quote-border);
            color: var(--quote-primary);
            font-size: 12px;
            font-weight: 900;
            white-space: nowrap;
          }

          .quote-detail-toggle {
            width: 30px;
            height: 30px;
            border-radius: 999px;
            border: 1px solid var(--quote-border);
            background: #f9fafb;
            color: var(--quote-primary);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 auto;
            transition: all 0.18s ease;
            padding: 0;
            font-size: 16px;
          }

          .quote-detail-toggle:hover {
            background: #f3f4f6;
            border-color: #d1d5db;
          }

          .quote-detail-toggle.is-open {
            background: var(--quote-primary);
            color: #fff;
            border-color: var(--quote-primary);
          }

          .quote-detail-toggle i,
          .quote-detail-toggle svg {
            transition: transform 0.18s ease;
          }

          .quote-detail-toggle.is-open i,
          .quote-detail-toggle.is-open svg {
            transform: rotate(180deg);
          }

          .quote-mobile-details {
            display: none;
            padding: 12px 0;
            border-top: 1px solid var(--quote-border);
            border-bottom: 1px solid var(--quote-border);
            animation: quoteDetailsSlide 0.18s ease-out;
          }

          .quote-mobile-details.open {
            display: block;
          }

          .quote-mobile-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          @keyframes quoteDetailsSlide {
            from { opacity: 0; transform: translateY(-4px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .quote-mobile-label {
            color: var(--quote-muted);
            font-size: 11px;
            font-weight: 850;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 3px;
          }

          .quote-mobile-value {
            color: var(--quote-primary);
            font-size: 13px;
            font-weight: 800;
            word-break: break-word;
          }

          .quote-mobile-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 12px;
          }

          .mobile-action-dropdown {
            position: relative;
            flex: 0 0 auto;
          }

          .mobile-action-toggle {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            min-height: 40px;
            padding: 9px 13px;
            border-radius: 12px;
            border: 1px solid var(--quote-primary);
            background: var(--quote-primary);
            color: #fff;
            font-size: 13px;
            font-weight: 900;
            box-shadow: 0 8px 18px rgba(17, 24, 39, 0.12);
          }

          }

          .mobile-action-dropdown .dropdown-item {
            display: flex;
            align-items: center;
            gap: 8px;
            border-radius: 10px;
            padding: 10px 12px;
            color: var(--quote-primary);
            font-size: 13px;
            font-weight: 800;
          }

          .mobile-action-dropdown .dropdown-item:hover {
            background: #f9fafb;
          }

          .mobile-action-dropdown .dropdown-item.text-success {
            color: #166534 !important;
          }

          .mobile-action-dropdown .dropdown-item.text-danger {
            color: #b91c1c !important;
          }

          .react-select .select__control {
            border: 1px solid #ced4da;
            border-radius: 4px;
            min-height: 38px;
          }

          .react-select.is-invalid .select__control {
            border-color: #dc3545;
          }

          .react-select .select__menu {
            z-index: 1050;
          }

          .ql-container {
            min-height: 150px;
            border-radius: 4px;
            border: 1px solid #ced4da;
          }

          .ql-toolbar {
            border-radius: 4px 4px 0 0;
            background-color: #f8f9fa;
          }

          .ql-editor {
            min-height: 100px;
          }

          .address-suggestions {
            position: absolute;
            z-index: 1000;
            background: white;
            border: 1px solid #ced4da;
            border-radius: 8px;
            width: 100%;
            max-height: 200px;
            overflow-y: auto;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            margin-top: 0.25rem;
          }

          .address-suggestions li {
            padding: 0.75rem;
            cursor: pointer;
            transition: background-color 0.2s ease;
          }

          .address-suggestions li:hover {
            background-color: #f8f9fa;
          }

          .quote-convert-modal .modal-content {
            border: 0;
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
          }

          .quote-convert-modal .modal-header {
            border-bottom: 1px solid var(--quote-border);
            padding: 18px 20px;
          }

          .quote-convert-modal .modal-title {
            color: var(--quote-primary);
            font-weight: 900;
          }

          .quote-convert-modal .modal-body {
            padding: 20px;
          }

          .quote-convert-modal .modal-footer {
            border-top: 1px solid var(--quote-border);
            padding: 16px 20px;
          }

          .quote-modal-confirm-card {
            border: 1px solid var(--quote-border);
            border-radius: 14px;
            background: #f9fafb;
            padding: 14px;
            color: var(--quote-primary);
            font-size: 14px;
            font-weight: 700;
          }

          @media (max-width: 767.98px) {
            .quote-list-card {
              border-radius: 14px;
              box-shadow: none;
            }

            .quote-list-header {
              flex-direction: column;
              align-items: stretch;
              padding: 16px;
            }

            .quote-add-btn {
              width: 100%;
            }

            .quote-list-body {
              padding: 14px;
            }

            .desktop-table-wrap {
              display: none;
            }

            .mobile-quote-list {
              display: block;
            }

            .quote-mobile-top {
              gap: 10px;
            }

            .quote-mobile-status-area {
              align-items: flex-start;
            }

            .quote-amount-badge {
              max-width: 126px;
              white-space: normal;
              line-height: 1.2;
              text-align: center;
            }

            .quote-mobile-grid {
              grid-template-columns: 1fr;
            }

            .quote-mobile-footer {
              align-items: stretch;
            }

            .mobile-action-toggle {
              min-width: 112px;
            }

            .quote-convert-modal {
              padding: 0 !important;
            }

            .quote-convert-modal .modal-dialog {
              margin: 0;
              max-width: 100%;
              min-height: 100vh;
              display: flex;
              align-items: stretch;
            }

            .quote-convert-modal .modal-content {
              min-height: 100vh;
              border-radius: 0;
              display: flex;
              flex-direction: column;
            }

            .quote-convert-modal .modal-header {
              position: sticky;
              top: 0;
              z-index: 5;
              background: #fff;
              padding: 14px 16px;
            }

            .quote-convert-modal .modal-body {
              flex: 1 1 auto;
              overflow-y: auto;
              padding: 16px;
            }

            .quote-convert-modal .modal-footer {
              flex-direction: column-reverse;
              align-items: stretch;
              padding: 14px 16px;
              background: #fff;
              box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.08);
            }

            .quote-convert-modal .modal-footer .btn {
              width: 100%;
              min-height: 42px;
              border-radius: 12px;
              font-weight: 800;
            }
          }
        `}
      </style>

      <div className="quote-list-card">
        <div className="quote-list-header">
          <div>
            <h5 className="quote-list-title">Quotes</h5>
            <p className="quote-list-subtitle">Manage quotes and convert accepted quotes into order forms.</p>
          </div>

          <Link className="quote-add-btn" to="/create-quote">
            Add New
          </Link>
        </div>

        <div className="quote-list-body">
          <div className="quote-search-section">
            <div className="quote-search-wrap">
              <i className="ph ph-magnifying-glass quote-search-icon" />
              <input
                type="text"
                className="quote-search-input"
                placeholder="Search quotes by customer name, phone, amount..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button
                  type="button"
                  className="quote-search-clear"
                  onClick={() => setSearchQuery('')}
                  aria-label="Clear search"
                >
                  <i className="ph ph-x" />
                </button>
              )}
            </div>
            <div className="quote-search-meta">
              Showing {filteredJobsData.length} of {jobsData.length} quotes
            </div>
          </div>

          <div className="desktop-table-wrap mt-16">
            <div className="table-responsive-shell">
              <table className="table bordered-table mb-0" id="dataTable">
                <thead>
                  <tr>
                    <th scope="col">Quote No</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Customer Phone</th>
                    <th scope="col">Issued Date</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>

          <div className="mobile-quote-list px-16 pt-16">
            {filteredJobsData.length === 0 ? (
              <div className="text-center text-muted py-4">No quotes found.</div>
            ) : (
              filteredJobsData.map((quote) => (
                <div className="quote-mobile-card" key={quote.id}>
                  <div className="quote-mobile-top">
                    <div className="quote-mobile-main">
                      <div className="quote-mobile-number">Quote #{quote.id}</div>
                      <div className="quote-mobile-customer">{quote.customer_name || 'Unknown Customer'}</div>
                    </div>

                    <div className="quote-mobile-status-area">
                      <span className="quote-amount-badge">{formatMoney(quote)}</span>
                      <button
                        type="button"
                        className={`quote-detail-toggle ${expandedMobileCards[quote.id] ? 'is-open' : ''}`}
                        onClick={() => toggleMobileDetails(quote.id)}
                        aria-expanded={!!expandedMobileCards[quote.id]}
                        aria-label={expandedMobileCards[quote.id] ? 'Hide quote details' : 'Show quote details'}
                      >
                        <i className="ph ph-caret-down" />
                      </button>
                    </div>
                  </div>

                  <div className={`quote-mobile-details ${expandedMobileCards[quote.id] ? 'open' : ''}`}>
                    <div className="quote-mobile-grid">
                      <div>
                        <div className="quote-mobile-label">Customer Phone</div>
                        <div className="quote-mobile-value">{quote.phone || '-'}</div>
                      </div>

                      <div>
                        <div className="quote-mobile-label">Issued Date</div>
                        <div className="quote-mobile-value">{formatDateString(quote.issue_date)}</div>
                      </div>

                      <div>
                        <div className="quote-mobile-label">Quote ID</div>
                        <div className="quote-mobile-value">#{quote.id}</div>
                      </div>

                      <div>
                        <div className="quote-mobile-label">Amount</div>
                        <div className="quote-mobile-value">{formatMoney(quote)}</div>
                      </div>
                    </div>
                  </div>

                  <div className="quote-mobile-footer">
                    <div className="dropdown mobile-action-dropdown">
                      <button
                        className="mobile-action-toggle dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        data-bs-boundary="viewport"
                        data-bs-display="dynamic"
                        aria-expanded="false"
                      >
                        Actions
                      </button>

                      <ul className="dropdown-menu dropdown-menu-end">
                        {canMakeInvoice && (
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-success"
                              onClick={() => handleMakeIt(quote.id)}
                            >
                              <i className="ph ph-file-arrow-up" /> Make it Order Form
                            </button>
                          </li>
                        )}

                        {canRead && (
                          <li>
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={() => navigate(`/quote-preview/${quote.id}`)}
                            >
                              <i className="ph ph-eye" /> View Quote
                            </button>
                          </li>
                        )}

                        {canEdit && (
                          <li>
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={() => navigate(`/quote-edit/${quote.id}`)}
                            >
                              <i className="ph ph-pencil" /> Edit Quote
                            </button>
                          </li>
                        )}

                        {canDelete && (
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-danger"
                              onClick={() => handleDelete(quote.id)}
                            >
                              <i className="ph ph-trash" /> Delete Quote
                            </button>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <Modal
        size="lg"
        show={showModal}
        onHide={closeConvertModal}
        centered
        dialogClassName="quote-convert-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="h6">Convert Quote to Order Form</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="quote-modal-confirm-card mb-3">
            Are you sure that you want to convert this quote into an order form?
          </div>

          <div className="mb-3">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-2"
              onClick={() => setShowOtherDetails((prev) => !prev)}
              style={{ fontWeight: 500, fontSize: '13px' }}
            >
              <Icon
                icon={showOtherDetails ? 'solar:alt-arrow-up-linear' : 'solar:add-circle-linear'}
                className="text-lg"
              />
              {showOtherDetails ? 'Hide other details' : '+ Add other details'}
            </button>
          </div>

          {showOtherDetails && (
            <div className="p-3 border rounded-3 bg-light mb-3">
              <div className="mb-3">
                <label className="form-label fw-semibold mb-1" style={{ fontSize: '13px' }}>
                  Bilty To:
                </label>
                <CreatableSelect
                  className="react-select"
                  classNamePrefix="react-select"
                  menuPosition="fixed"
                  value={biltyTo ? { label: biltyTo, value: biltyTo } : null}
                  onChange={(selected) => setBiltyTo(selected ? selected.value : null)}
                  onCreateOption={(val) => setBiltyTo(val)}
                  options={biltyOptions}
                  placeholder="Select Sub Branch"
                  isClearable={true}
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                  }}
                />
              </div>

              <div>
                <label className="form-label fw-semibold mb-1" style={{ fontSize: '13px' }}>
                  Commission:
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter commission..."
                  value={commission}
                  onChange={(e) => setCommission(e.target.value)}
                  style={{ fontSize: '13.5px' }}
                />
              </div>
            </div>
          )}

          {errors.submit && (
            <div className="alert alert-danger mt-3">{errors.submit}</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeConvertModal}>
            Cancel
          </Button>
          <Button
            style={{ background: '#111827', borderColor: '#111827' }}
            onClick={handleSubmit}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QuoteListLayer;
